/**
 * User form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';
import { Field } from 'redux-form';
import FormGroup from 'Components/FormGroup';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { CustomFormInput } from 'Common/Form';
import { maxLengthValidation, isOrcidValidation } from 'Utils';

const maxLength255 = maxLengthValidation(255);

export default function IdsInfoForm(props) {
    return (
        <FormGroup title="form_groups.ids_info" {...props}>
            <Field
                rowClassName="mm-form-field"
                name="orcid_id"
                component={CustomFormInput}
                type="text"
                label="orcid_id"
                placeholder="orcid_id"
                withLabel
                validate={[isOrcidValidation]}
                additionalLabel={
                    <div name="orcid_link">
                        <FormattedMessage
                            id="field.orcid_link.label"
                            values={{ link: <Link to={'https://orcid.org'} target="_blank">link</Link> }}
                        />
                    </div>
                }
            />



            <Field
                rowClassName="mm-form-field"
                name="researcher_id"
                component={CustomFormInput}
                type="text"
                label="researcher_id"
                placeholder="researcher_id"
                withLabel
                validate={[maxLength255]}
            />
        </FormGroup>
    );
}



// WEBPACK FOOTER //
// ./src/components/FormGroup/IdsInfoForm.jsx